import { gql } from "@medbillai/generated-graphql-types";

export const getIssuesQueryV2 = gql(/* GraphQL */ `
  query QueryIssuesV2(
    $closed: Boolean
    $unread: Boolean
    $read: Boolean
    $open: Boolean
    $first: Int
    $after: Int
  ) {
    queryIssuesV2(
      closed: $closed
      unread: $unread
      read: $read
      open: $open
      first: $first
      after: $after
    ) {
      __typename
      id
      title
      openedAt
      closedAt
      lastEvent {
        __typename
        id
        sentAt
        eventType
        participant
        ... on issue__ChatEvent_Type {
          chatBody
        }
        ... on issue__TemplateReleaseRequestedEvent_Type {
          template {
            description
          }
        }
        ... on issue__BillPaymentRequestedEvent_Type {
          acceptedAt
          billPaid
        }
        ... on issue__ConnectInsuranceRequestedEvent_Type {
          insuranceLinkMessage
        }
        ... on issue__UserSelectionRequestedEvent_Type {
          stringMessage: message
        }
        ... on issue__UserMultiSelectionRequestedEvent_Type {
          multiMessage: message
        }
      }
      firstUnseenEvent {
        __typename
        id
        sentAt
        eventType
        participant
        ... on issue__ChatEvent_Type {
          chatBody
        }
        ... on issue__TemplateReleaseRequestedEvent_Type {
          template {
            description
          }
        }
        ... on issue__BillPaymentRequestedEvent_Type {
          acceptedAt
          billPaid
        }
        ... on issue__ConnectInsuranceRequestedEvent_Type {
          insuranceLinkMessage
        }
        ... on issue__UserSelectionRequestedEvent_Type {
          stringMessage: message
        }
        ... on issue__UserMultiSelectionRequestedEvent_Type {
          multiMessage: message
        }
      }
    }
  }
`);

export const openNewIssueFromPreviewMutation = gql(/* GraphQL */ `
  mutation OpenNewIssueFromPreview($input: OpenNewIssueFromPreviewInput!) {
    openNewIssueFromPreview(input: $input) {
      __typename
      id
      title
      openedAt
    }
  }
`);
